import { Auth0Config } from './auth0Config';
import { CloudinaryConfig } from './cloudinaryConfig';

export class AppConfig {
  public readonly baseApiUrl: string;
  public readonly production: boolean;
  public readonly staging: boolean;
  public readonly name: string;
  public readonly version: string;
  public readonly whitelistedDomain: string;
  public readonly recaptchaSiteKey: string;
  public readonly auth: Auth0Config;
  public readonly cloudinary: CloudinaryConfig;

  constructor(
    production: boolean,
    staging: boolean,
    name: string,
    version: string,
    whitelistedDomain: string,
    recaptchaSiteKey: string,
    baseApiUrl: string,
    auth: Auth0Config,
    cloudinary: CloudinaryConfig
  ) {
    this.production = production;
    this.staging = staging;
    this.name = name;
    this.version = version;
    this.whitelistedDomain = whitelistedDomain;
    this.recaptchaSiteKey = recaptchaSiteKey;
    this.auth = auth;
    this.cloudinary = cloudinary;

    this.baseApiUrl =
      this.name === 'dev' || this.name === 'development'
        ? baseApiUrl
        : window.location.origin.concat('/api/');
  }

  static parse(obj: any): AppConfig {
    if (!obj) return;

    return new AppConfig(
      obj.production,
      obj.staging,
      obj.name,
      obj.version,
      obj.whitelistedDomain,
      obj.recaptchaSiteKey,
      obj.baseApiUrl,
      Auth0Config.parse(obj.auth),
      CloudinaryConfig.parse(obj.cloudinary)
    );
  }
}
